var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("h1", { staticClass: "subtitle is-5" }, [
      _vm._v("Usuarios de la organización"),
    ]),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-1" }, [_vm._v("Roles por defecto")]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("section", [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-message",
              { attrs: { type: "is-primary" } },
              [
                _c("h1", { staticClass: "title is-5" }, [
                  _vm._v("Roles por defecto"),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "subtitle is-6 is-mono" }, [
                  _vm._v("Arrastre aquí para activar"),
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  _vm._b(
                    {
                      staticStyle: { "min-height": "25px" },
                      attrs: { tag: "b-taglist" },
                      on: {
                        start: function ($event) {
                          _vm.drag = true
                        },
                        end: function ($event) {
                          _vm.drag = false
                        },
                      },
                      model: {
                        value: _vm.rolesDefault,
                        callback: function ($$v) {
                          _vm.rolesDefault = $$v
                        },
                        expression: "rolesDefault",
                      },
                    },
                    "draggable",
                    { group: "roles" },
                    false
                  ),
                  _vm._l(_vm.rolesDefault, function (rolDefault) {
                    return _c(
                      "b-tag",
                      {
                        key: rolDefault.id,
                        attrs: { type: "is-primary", size: "is-medium" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(rolDefault.descripcion) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "b-message",
              [
                _c("h1", { staticClass: "title is-5" }, [
                  _vm._v("Roles disponibles"),
                ]),
                _vm._v(" "),
                _c("h1", { staticClass: "subtitle is-6 is-mono" }, [
                  _vm._v("Arrastre aquí para desactivar"),
                ]),
                _vm._v(" "),
                _c(
                  "draggable",
                  _vm._b(
                    {
                      staticStyle: { "min-height": "25px" },
                      attrs: { tag: "b-taglist" },
                      on: {
                        start: function ($event) {
                          _vm.drag = true
                        },
                        end: function ($event) {
                          _vm.drag = false
                        },
                      },
                      model: {
                        value: _vm.rolesOrg,
                        callback: function ($$v) {
                          _vm.rolesOrg = $$v
                        },
                        expression: "rolesOrg",
                      },
                    },
                    "draggable",
                    { group: "roles" },
                    false
                  ),
                  _vm._l(_vm.availableRoles, function (rolOrg) {
                    return _c(
                      "b-tag",
                      {
                        key: rolOrg.id,
                        attrs: { type: "is-black", size: "is-medium" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(rolOrg.descripcion) +
                            "\n            "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.submit()
              },
            },
          },
          [_c("i", { staticClass: "fas fa-save fa-fw" }), _vm._v(" Guardar")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v(
          "\n    Defina que roles se asignan automaticamente para cada nuevo usuario. Los roles son parte de los modulos instalados de la organización.\n    "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }